import useAxios from 'axios-hooks';

import { url } from 'constants/index';
import { buildRequestParams } from 'utils/pagination.utils';

export const useSeasonsTrimmed = (filters?: Array<PaginationFilter>, manual = false) => {
  const [{ data, loading: isLoading, error }] = useAxios<PaginationData<Entity>>(
    {
      url: `${url.seasons}/trimmed`,
      params: buildRequestParams({ pageSize: 200, filters }),
    },
    { manual },
  );
  return { seasons: data?.items || [], error, isLoading };
};
